<div class="documents-tabs-container">
  <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)" [dynamicHeight]="true"
    class="documents-tabs-group">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>cloud_upload</mat-icon>
        {{ translate('upload.title') }}
      </ng-template>
      <app-upload></app-upload>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>folder</mat-icon>
        {{ translate('documents.tab_viewer') }}
      </ng-template>
      <app-drive-viewer [active]="selectedTabIndex === 1"></app-drive-viewer>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>insert_chart</mat-icon>
        {{ translate('documents.tab_overview') }}
      </ng-template>
      <app-document-overview [active]="selectedTabIndex === 2" (typeSelected)="setOverviewFilter($event)"></app-document-overview>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>hub</mat-icon>
        {{ translate('documents.tab_network') }}
      </ng-template>
      <app-document-network [active]="selectedTabIndex === 3" [filterType]="overviewSelectedType" [filterDomain]="networkSelectedDomain"
        (domainSelected)="setNetworkFilter($event)">
      </app-document-network>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon>list_alt</mat-icon>
        {{ translate('documents.tab_details') }}
      </ng-template>
      <app-document-details [filterType]="overviewSelectedType" [filterDomain]="networkSelectedDomain"
        [documentIds]="detailsDocumentIds"></app-document-details>
    </mat-tab>
  </mat-tab-group>
</div>